// removed by extract-text-webpack-plugin
module.exports = {"container":"ServiceCatalogContainer__container___3hIA7"};